import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  ElementRef,
  OnDestroy,
  Input,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Country, Organization } from '../../shared/sdk/models';
import { OrganizationService } from '../../organizations/organization.service';
import { TaxService } from '../tax.service';
import { Tax } from '../../shared/sdk/models/Tax';
import { LanguageService } from '../../shared/services/language.service';
import Decimal from 'decimal.js';
import { Observable, Subject, zip } from 'rxjs';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil, map, filter } from 'rxjs/operators';
import { CountryService } from '../../shared/services/country.service';

@Component({
  selector: 'app-tax-add',
  templateUrl: './tax-add.component.html',
  styleUrls: ['./tax-add.component.css'],
})
export class TaxAddComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() tax: Tax;
  @ViewChild('taxName', { static: true }) taxName: ElementRef;
  activeOrg: Organization;
  countries$: Observable<Country[]>;
  sent: boolean;
  showAdvanced = false;
  taxForm: FormGroup;
  private onDestroy$: Subject<void> = new Subject();

  constructor(
    private activeModal: NgbActiveModal,
    private countryService: CountryService,
    private languageService: LanguageService,
    private orgService: OrganizationService,
    private taxService: TaxService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.taxForm = this.fb.group({
      name: ['', Validators.required],
      abbreviation: ['', Validators.required],
      recoverable: [true, Validators.required],
      compound: [false, Validators.required],
      taxNumber: [''],
      country: [''],
      _taxRates: this.fb.array([
        this.fb.group({
          rate: ['', Validators.required],
        }),
      ]),
      custom: [],
    });

    if (!this.tax) {
      this.tax = new Tax();
    } else {
      this.tax = new Tax(this.tax);
      this.taxForm.patchValue(this.tax);

      if (this.tax.country) {
        this.showAdvanced = true;
      }
    }

    this.countries$ = zip(
      this.countryService.get(),
      this.countryService.get({ skip: 100 }),
      this.countryService.get({ skip: 200 }),
    ).pipe(map(([a, b, c]) => [...a.body, ...b.body, ...c.body]));

    this.orgService.active
      .pipe(
        filter((org) => !!org),
        takeUntil(this.onDestroy$)
      )
      .subscribe((org: Organization) => {
        this.activeOrg = org;
      });
  }

  ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  ngAfterViewInit() {
    setTimeout(() => this.taxName.nativeElement.focus(), 100);
  }

  onClose() {
    this.activeModal.dismiss();
  }

  onSave() {
    this.sent = true;

    if (this.taxForm.valid) {
      const taxFormValue = this.taxForm.value;
      const editing = !!this.tax.id;

      let taxRate = taxFormValue._taxRates[0].rate;
      taxRate = this.languageService.unformatNumber(taxRate);
      taxRate = new Decimal(taxRate).toDP(2, Decimal.ROUND_FLOOR).toNumber();

      taxFormValue._taxRates[0].rate = taxRate;

      this.taxService[!editing ? 'create' : 'update'](
        !editing ? this.activeOrg.id : this.tax.id,
        taxFormValue,
      ).subscribe((tax) => {
        this.activeModal.close(tax);
      });
    }
  }
}
